(function () {
    'use strict';

    angular
        .module('app.bestPerformingInfluencersReport',[])
        .factory('bestPerformingInfluencersReportService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url) {
                    var deferred = $q.defer(), result = 'requestFail';
                    $http.get(url)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes) || result);
                            }
                        })
                        .error(function () {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function getBestPerformingInfluencers(params)
                {
                    var url_getBestPerformingInfluencers = $rootScope.apiUrl + 'measure/getBestPerformingInfluencers?' + $.param(params);
                    return handleRequest(url_getBestPerformingInfluencers);
                }

                service.getBestPerformingInfluencers = getBestPerformingInfluencers;
                
                return service;
            }
        ]);
})();
